var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCheckNewDesign = function SvgIconCheckNewDesign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1ZM11.045 6.411L7.111 10.345C7.04749 10.4127 6.95881 10.4511 6.866 10.4511C6.77319 10.4511 6.68451 10.4127 6.621 10.345L4.955 8.7C4.88874 8.63428 4.85147 8.54482 4.85147 8.4515C4.85147 8.35818 4.88874 8.26872 4.955 8.203L5.326 7.832C5.38951 7.76433 5.47819 7.72594 5.571 7.72594C5.66381 7.72594 5.75249 7.76433 5.816 7.832L6.866 8.875L10.184 5.557C10.3201 5.4236 10.5379 5.4236 10.674 5.557L11.045 5.928C11.1739 6.0632 11.1739 6.2758 11.045 6.411Z",
    fill: "#0930CC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCheckNewDesign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconCheckNewDesign.ad19ea12.svg";
export { ForwardRef as ReactComponent };